require("core-js/modules/es.promise.finally");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("final-form-arrays"), require("final-form")) : "function" == typeof define && define.amd ? define(["exports", "final-form-arrays", "final-form"], e) : e((t = t || self)["@tinacms/forms"] = {}, t.arrayMutators, t.finalForm);
}(this, function (t, h, b) {
  "use strict";

  h = h && h.hasOwnProperty("default") ? h.default : h;

  var _m = function m() {
    return (_m = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) {
        for (var r in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  };

  function y(o, a, u, l) {
    return new (u = u || Promise)(function (t, e) {
      function n(t) {
        try {
          r(l.next(t));
        } catch (t) {
          e(t);
        }
      }

      function i(t) {
        try {
          r(l.throw(t));
        } catch (t) {
          e(t);
        }
      }

      function r(e) {
        e.done ? t(e.value) : new u(function (t) {
          t(e.value);
        }).then(n, i);
      }

      r((l = l.apply(o, a || [])).next());
    });
  }

  function d(n, i) {
    var r,
        o,
        a,
        t,
        u = {
      label: 0,
      sent: function sent() {
        if (1 & a[0]) throw a[1];
        return a[1];
      },
      trys: [],
      ops: []
    };
    return t = {
      next: e(0),
      throw: e(1),
      return: e(2)
    }, "function" == typeof Symbol && (t[Symbol.iterator] = function () {
      return this;
    }), t;

    function e(e) {
      return function (t) {
        return function (e) {
          if (r) throw new TypeError("Generator is already executing.");

          for (; u;) {
            try {
              if (r = 1, o && (a = 2 & e[0] ? o.return : e[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, e[1])).done) return a;

              switch (o = 0, a && (e = [2 & e[0], a.value]), e[0]) {
                case 0:
                case 1:
                  a = e;
                  break;

                case 4:
                  return u.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  u.label++, o = e[1], e = [0];
                  continue;

                case 7:
                  e = u.ops.pop(), u.trys.pop();
                  continue;

                default:
                  if (!(a = 0 < (a = u.trys).length && a[a.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    u = 0;
                    continue;
                  }

                  if (3 === e[0] && (!a || e[1] > a[0] && e[1] < a[3])) {
                    u.label = e[1];
                    break;
                  }

                  if (6 === e[0] && u.label < a[1]) {
                    u.label = a[1], a = e;
                    break;
                  }

                  if (a && u.label < a[2]) {
                    u.label = a[2], u.ops.push(e);
                    break;
                  }

                  a[2] && u.ops.pop(), u.trys.pop();
                  continue;
              }

              e = i.call(n, u);
            } catch (t) {
              e = [6, t], o = 0;
            } finally {
              r = a = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, t]);
      };
    }
  }

  var e = (Object.defineProperty(n.prototype, "name", {
    get: function get() {
      return this.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(n.prototype, "values", {
    get: function get() {
      if (!this.loading) return this.finalForm.getState().values || this.initialValues;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(n.prototype, "initialValues", {
    get: function get() {
      return this.finalForm.getState().initialValues;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(n.prototype, "pristine", {
    get: function get() {
      return this.finalForm.getState().pristine;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(n.prototype, "dirty", {
    get: function get() {
      return this.finalForm.getState().dirty;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(n.prototype, "submitting", {
    get: function get() {
      return this.finalForm.getState().submitting;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(n.prototype, "valid", {
    get: function get() {
      return this.finalForm.getState().valid;
    },
    enumerable: !0,
    configurable: !0
  }), n.prototype.reset = function () {
    return y(this, void 0, void 0, function () {
      return d(this, function (t) {
        switch (t.label) {
          case 0:
            return this._reset ? [4, this._reset()] : [3, 2];

          case 1:
            t.sent(), t.label = 2;

          case 2:
            return this.finalForm.reset(), [2];
        }
      });
    });
  }, n.prototype.updateFields = function (t) {
    this.fields = t;
  }, n.prototype.change = function (t, e) {
    return this.finalForm.change(t, e);
  }, Object.defineProperty(n.prototype, "mutators", {
    get: function get() {
      return this.finalForm.mutators;
    },
    enumerable: !0,
    configurable: !0
  }), n.prototype.updateValues = function (t) {
    var e = this;
    this.finalForm.batch(function () {
      e.finalForm.getState().active ? u(e.finalForm, t) : i(e.finalForm, t);
    });
  }, n.prototype.updateInitialValues = function (e) {
    var n = this;
    this.finalForm.batch(function () {
      var t = n.values || {};
      n.finalForm.initialize(e), n.finalForm.getState().active ? u(n.finalForm, t) : i(n.finalForm, t);
    });
  }, n);

  function n(t) {
    var o = this,
        e = t.id,
        n = t.label,
        i = t.fields,
        r = t.actions,
        a = t.buttons,
        u = t.reset,
        l = t.loadInitialValues,
        s = t.onChange,
        f = function (t, e) {
      var n = {};

      for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
      }

      if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;

        for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
          e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
        }
      }

      return n;
    }(t, ["id", "label", "fields", "actions", "buttons", "reset", "loadInitialValues", "onChange"]);

    this.loading = !1, this.subscribe = function (t, e) {
      return o.finalForm.subscribe(t, e);
    }, this.handleSubmit = function (n, i, r) {
      return y(o, void 0, void 0, function () {
        var e;
        return d(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.onSubmit(n, i, r)];

            case 1:
              return e = t.sent(), i.initialize(n), [2, e];
          }
        });
      });
    }, this.submit = function () {
      return o.finalForm.submit();
    };
    var c = f.initialValues || {};

    if (this.__type = f.__type || "form", this.id = e, this.label = n, this.fields = i, this.onSubmit = f.onSubmit, this.finalForm = b.createForm(_m(_m({}, f), {
      initialValues: c,
      onSubmit: this.handleSubmit,
      mutators: _m(_m({}, h), f.mutators)
    })), this._reset = u, this.actions = r || [], this.buttons = a || {
      save: "Save",
      reset: "Reset"
    }, this.updateFields(this.fields), l && (this.loading = !0, l().then(function (t) {
      o.updateInitialValues(t);
    }).finally(function () {
      o.loading = !1;
    })), s) {
      var p = !0;
      this.subscribe(function (t) {
        p ? p = !1 : s(t);
      }, {
        values: !0
      });
    }
  }

  function i(i, t) {
    Object.entries(t).forEach(function (t) {
      var e = t[0],
          n = t[1];
      i.change(e, n);
    });
  }

  function u(r, t, o) {
    var a = r.getState().active;
    Object.entries(t).forEach(function (t) {
      var e = t[0],
          n = t[1],
          i = o ? o + "." + e : e;
      "object" == typeof n ? a.startsWith(i) ? u(r, n, i) : r.change(i, n) : i !== a && r.change(i, n);
    });
  }

  t.Form = e, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});